import React from "react";
import useGeotabDay from "../../hooks/useGeotabDay.js";
import { geotabTruckOf } from "../../utils/consolidationGeotabFill.js";
import { fmtTime } from "../geotab/geotabFormat.js";

// Camions réellement conduits selon Geotab, quand ce n'est pas seulement le camion du Dispatch.
// hidden : la question « Qui a conduit ? » nomme déjà l'autre camion, sur une seule ligne.
export default function GeotabTrucksLine({ row, enabled, hidden = false }) {
  const truck = geotabTruckOf(useGeotabDay(row.dispatch_date, row.dispatch_period, enabled && !row.manual_order_id), row);
  const used = truck?.trucks_used || [];
  if (hidden || !used.some((u) => !u.planned)) return null;
  return <p role="note" className="flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-xs text-slate-700">
    <span className="rounded-[4px] bg-[#ffc400] px-1.5 text-[11px] font-bold text-[#1f1a05]">{used.length > 1 ? `${used.length} camions` : "Autre camion"}</span>
    <span>Geotab : {used.map((u, i) => <React.Fragment key={`${u.device_id}:${i}`}>{i ? ", puis " : ""}<b className="text-slate-900">{u.name}</b>{u.planned ? " (prévu)" : ""} de {fmtTime(u.start)} à {fmtTime(u.end)}</React.Fragment>)}
      {used.length === 1 ? <>, au lieu du <b className="text-slate-900">{truck.truck_name}</b></> : null}</span>
  </p>;
}
